<template>
  <div>
    <h3 class="mb-5">每月營收報告</h3>
    <div class="pa-5 text-center gray-200" style="font-size:14px;">
      {{ financial.title }}年每月合併營收報告(單位：仟元)
    </div>
    <table>
      <thead class="gray-100 shadow-bottom">
        <tr>
          <th rowspan="2" class="w-76px shadow-right">
            月份
          </th>
          <th colspan="3" class="h-60px shadow-bottom">營業收入</th>
          <th colspan="3" class="h-60px shadow-bottom">累計營業收入</th>
        </tr>
        <tr class="h-80px">
          <th>當月營收</th>
          <th>{{ financial.title }}年 <br />當月營收</th>
          <th>較{{ parseInt(financial.title) - 1 }}年 <br />當月增減(%)</th>
          <th>年度累計 <br />營收</th>
          <th>{{ parseInt(financial.title) - 1 }}年 <br />累計營收</th>
          <th>年度增減</th>
        </tr>
      </thead>
      <tbody>
        <tr
          class="shadow-bottom"
          v-for="(item, i) in financial.monthly_revenue"
          :key="`month-${i}`"
        >
          <th>{{ i + 1 }}月
          </th>
          <td>
            <div class="form-input-group">
              <input type="text" v-model="item.revenue" />
            </div>
          </td>
          <td>
            <div class="form-input-group">
              <input type="text" v-model="item.last_revenue" />
            </div>
          </td>
          <td>
            <div class="form-input-group">
              <input type="text" v-model="item.mom" />
            </div>
          </td>
          <td>
            <div class="form-input-group">
              <input type="text" v-model="item.current_cumulative_revenue" />
            </div>
          </td>
          <td>
            <div class="form-input-group">
              <input type="text" v-model="item.last_cumulative_revenue" />
            </div>
          </td>
          <td>
            <div class="form-input-group">
              <input type="text" v-model="item.yoy" />
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    financial: {
      type: Object,
      default: () => ({}),
    },
  },
  created() {
  },
  data: () => ({

  }),
};
</script>

<style lang="scss" scoped>
table {
  border-spacing: 0;

  .shadow-right {
    box-shadow: inset -1px 0 0 0 #d7dee7;
  }
  .shadow-bottom {
    box-shadow: inset 0 -1px 0 0 #d7dee7;
  }
}
thead {
  td,
  th {
    font-size: 14px;
  }
}
tbody {
  tr {
    height: 60px;
  }
  th {
    font-size: 14px;
  }
  td {
    padding: 0 6px;
  }
  .form-input-group {
    input {
      text-align: right;
    }
  }
}
</style>
